<template>
  <div class="machine">
    <h1 class="machine-title">機械について</h1>
    <div class="machine-container">
       <img class="machine-topimg" src="./img/machine_top1.png">
      <h2 class="machine-text">こだわり抜いたオリジナル機械</h2>
      <!-- <div class="machine-line"></div> -->
      <p class="machine-toptextbox">自分で使えるのにサロン級の効果、かつ安価で安全。しかも施術時間は顔ならまず10分以内で施術可能。 全てを取り揃えたマシンを開発しました。メイクしたままでも使えるように設計することで、フラっと寄れる、スキマ時間で行けるエステを実現。 使い方も簡単だから安心して使える！</p>
      <div class="machine-contentsbox">
      <div class="machine-contents">
        <img class="machine-name" src="./img/machine_name1.png">
        <img class="machine-img" src="./img/hifu.png">
        <p class="machine-textbox">ハイフは日本語で高密度焦点式超音波と言います。超音波とは言っても人間に聞こえる可聴周波数を超えているので音は聞こえません。肌の深い位置まで熱として作用します。
真皮に当てるとコラーゲンなどのタンパク質を刺激し肌にハリや潤いを与えます。
SMAS層という筋膜に当てると、SMAS層を引き締め、たるみやシワなどを改善し、スリムアップ効果がみられます。</p>
      </div>

      <div class="machine-contents">
        <img class="machine-name" src="./img/machine_name2.png">
        <img class="machine-img" src="./img/radio.png">
        <p class="machine-textbox">電極から出たラジオ波が体内の細胞に振動を与え、体内の温度が上昇します。
リンパの流れがスムーズになるのでキャビテーションとの相性がとても良く、セットで利用するのがオススメです。
弊社のマシンはラジオ波とキャビテーションを交互に出力できます。
同じハンドピースで出力する事で施術時間の短縮＆ラジオ波の熱で軟らかくなった脂肪をキャビテーションがさらに効率良く処理する相乗効果が得られます！！</p>
      </div>

      <div class="machine-contents">
        <img class="machine-name" src="./img/machine_name3.png">
        <img class="machine-img" src="./img/cavi.png">
        <p class="machine-textbox">キャビテーションによって作られた気泡が消滅(破裂)する時に、非常に大きな衝撃波が発生します。
この衝撃波を体脂肪の排出に利用します。
体脂肪はリンパ経由で尿や血管から排出されるので施術後のリンパマッサージや施術前のラジオ波がオススメ。
弊社のマシンはラジオ波とキャビテーションを交互に出力できるのでより効率的に効果が得られます。</p>
      </div>
      </div>
    </div>
    <!--<div class="sales-phrases-box">
      <img class="sales-phrases-img disp-pc" src="./img/sales-phrases_pc.png" alt="機械について">
      <img class="sales-phrases-img disp-sp" src="./img/sales-phrases_sp.png" alt="機械について">
      <div class="sales-phrases">
        <p class="sales-phrases-title">
          独自開発！<br>
          早い・簡単・安全を兼ね備えた最高級マシン
        </p>
        <p class="sales-phrases-content">
          自分で使えるのにサロン級の効果、かつ安価で安全。しかも施術時間は顔ならまず10分以内で施術可能。
          全てを取り揃えたマシンを開発しました。メイクしたままでも使えるように設計することで、フラっと寄れる、スキマ時間で行けるエステを実現。
          使い方も簡単だから安心して使える！
        </p>
      </div>
    </div>
    <div class="machine-box">
      <div class="machine-container" v-for="machine in  machineExplanations" :key="machine.title">
        <img class="machine-img" :src=machine.imgPath :alt=machine.imgtitle />
        <div class="machine-content">
          <div class="machine-text-title">
            {{ machine.title }}
          </div>
          <div class="machine-explanation">
            <span v-html="machine.explanation"></span>
          </div>
        </div>
      </div>
    </div>-->
    <div class="advertising-phrase">
      <p class="advertising-phrase-sub">皆様に安心して使って頂くために、衛生面を考慮して</p>
      <p class="advertising-phrase-main">全機材、紫外線消毒機能付き</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
    // なし
  },
  data:function(){
    return{
      machineExplanations:[
        {
        imgPath:require('./img/hifu.png'),
        imgtitle:'ハイフ',
        title:'ハイフ',
        explanation:`ハイフは日本語で高密度焦点式超音波と言います。超音波とは言っても人間に聞こえる可聴周波数を超えているので音は聞こえません。肌の深い位置まで熱として作用します。
真皮に当てるとコラーゲンなどのタンパク質を刺激し肌にハリや潤いを与えます。
SMAS層という筋膜に当てると、SMAS層を引き締め、たるみやシワなどを改善し、スリムアップ効果がみられます。`
        },
        {
        imgPath:require('./img/radio.png'),
        imgtitle:'ラジオ波',
        title:'ラジオ波',
        explanation:`電極から出たラジオ波が体内の細胞に振動を与え、体内の温度が上昇します。
リンパの流れがスムーズになるのでキャビテーションとの相性がとても良く、セットで利用するのがオススメです。
弊社のマシンはラジオ波とキャビテーションを<span class="font-main-color">同時に出力できます</span>。
同時に出力する事で施術時間の短縮＆ラジオ波の熱で軟らかくなった脂肪をキャビテーションがさらに効率良く処理する相乗効果が得られます！！`
        },
        {
        imgPath:require('./img/cavi.png'),
        imgtitle:'キャビテーション',
        title:'キャビテーション',
        explanation:`キャビテーションは、高速の振動で脂肪に気泡を発生させます。
キャビテーションによって作られた気泡が消滅(破裂)する時に、非常に大きな衝撃波が発生します。
この衝撃波を体脂肪の排出に利用します。
体脂肪はリンパ経由で尿や血管から排出されるので施術後のリンパマッサージや施術前のラジオ波がオススメ。
弊社のマシンはラジオ波とキャビテーションを同時に出力できるので<span class="font-main-color">より効率的に効果が得られます。</span>`
        },
      ]
    }
  }
}
</script>

<style scoped>
  @import "../../css/style.css";
  .mg-t-100{
    margin-top: 100px;
  }

  /* v-htmlを使用したclassの適用を行う際にはディープセレクタを使用する必要があるらしい */
  /deep/ .font-main-color{
    color: var(--main-color);
  }



  .machine-contentsbox{

    clear: both;
    margin: 100px auto;
    text-align: center;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;



  }

   /* PC表示 */
  @media screen and (min-width:821px){
    .disp-pc{
      display: block;
    }

    .disp-sp{
      display: none;
    }
    
    .machine-title{
      color: var(--main-color);
      font-size: 2.5rem;
      letter-spacing: 0.2em;
      text-align: center;
      margin: 50px auto;
    }

    /*
    .sales-phrases-box{
      display:flex;
      justify-content: center;
      margin-bottom: 100px;
    }

    .sales-phrases-img{
      box-shadow:-50px 50px 0 0 var(--sub-color);
    }

    .sales-phrases{
      width: 35vw;
    }

    .sales-phrases-title{
      font-size: 1.5rem;
      color: var(--main-color);
      font-weight: 600;
      margin: 2em auto;
    }

    .sales-phrases-content{
      line-height: 1.5em;
    }
    .machine-box{
      width: 75vw; 
      left: 0;
      right: 0;
      margin: auto;
    }
    .machine-container{
      width: 65vw;
      /*display:flex;
      margin: 5em auto;
    }*/

    .machine-img{
      width: 150px;
      /*margin-right:50px;*/
      margin: 35px auto;
      display: block;
    }
    
    .machine-content{
      width: 60%;
    }

    .machine-text-title{
      color: var(--main-color);
      font-size: 2rem;
      font-weight: 600;

      margin-bottom: 0.5em;
    }

    .machine-explanation{
      /*color: black;*/
      white-space: pre-wrap;

      line-height: 1.5em;
    }
    

    .advertising-phrase{
      color: var(--main-color);
      width: 50vw;
      background-color: rgb(235, 235, 235);
      left: 0;
      right: 0;
      margin: 30px auto;
      padding:4em 3em;
      text-align: center;

    }

    .advertising-phrase-main{
      font-size: 2.5rem;
      font-weight: 600;
      -moz-text-align-last: justify;
      text-align-last: justify;
      padding-top:10px;
    }

    .advertising-phrase-sub{
      font-size: 1.5rem;
      font-weight: 600;
      -moz-text-align-last: justify;
      text-align-last: justify;
    }

  

  /*PC表示ここからーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー */

  .machine{

    width:100%;
    overflow-x:hidden;
  }
  .machine-container{

    width: 80vw;
    margin: 0 auto;
    clear: both;
    
  }

  .machine-text{

    text-align: center;
    font-size:25px;
    color:#000;
  }
  
  .machine-line{

    width:500px;
    border:0.5px solid #707070;
    margin: 35px auto;
  }

  .machine-toptextbox{

    width: 60vw;
    margin: 0 auto;
    line-height: 1.8em;
    font-weight: 600;
    color:#000;
    margin-top:50px;
    display: block;
  }
  
  .machine-topimg{

    margin: 60px auto;
    display: block;
    width: 80%;
  }

  .machine-contentsbox{

    clear: both;
    margin: 100px auto;
    text-align: center;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;


  }

  .machine-contents{

    width: 180px;
    /*display: inline-block;*/
    
    vertical-align:top;
    margin: 0 50px;
    text-align: justify;
   text-justify: inter-ideograph;
   display: block;
    
  }

  .machine-name{

    height: 30px;
    display: block;
  }

  .machine-textbox{
  vertical-align:top;
  font-weight: 600;
  color:#000;
  /*width: 170px;*/
  /*text-align:left;*/
  margin-right: 0;
  line-height: 1.7em;
  margin-top:10px;
  display: block;
  }
  }

  /* スマホ表示 */
  @media screen and (max-width:820px){
    .disp-pc{
      display: none;
    }

    .disp-sp{
      display: block;
    }

    .machine-title{
      color: var(--main-color);
      font-size: 5vw;
      letter-spacing: 0.2em;
      text-align: center;
      margin: 1em 0;
    }

    .sales-phrases-box{
      display:flex;
      justify-content: center;
      flex-wrap: wrap;
      margin-bottom: 30px;
    }

    .sales-phrases-img{
      width: 80vw;
      height: 44.5vw;
      /*object-fit: contain;*/
    }

    .sales-phrases{
      width: 80vw;
    }

    .sales-phrases-title{
      font-size: 3vw;
      color: var(--main-color);
      font-weight: 600;
      margin: 1em auto;
    }

    .sales-phrases-content{
      font-size: 2vw;
      line-height: 1.5em;
    }

    .machine-box{
      width: 100vw; 
      left: 0;
      right: 0;
      margin: auto;
    }

    .machine-container{
      width: 80%;
      margin: 5em auto;
    }

    .machine-img{
      width: 100%;
    }
    
    .machine-content{
      width: 100%;
    }

    .machine-text-title{
      color: var(--main-color);
      font-size: 5vw;
      font-weight: 600;

      margin-bottom: 0.5em;
    }

    .machine-explanation{
      /*color: black;*/
      white-space: pre-wrap;

      line-height: 1.5em;
      font-size: 3vw;
    }

    .advertising-phrase{
      color: var(--main-color);
      width: 80vw;
      background-color: rgb(235, 235, 235);
      left: 0;
      right: 0;
      margin: 30px auto;
      padding:5vw 7vw;
      text-align: center;

    }

    .advertising-phrase-main{
      font-size: 5vw;
      font-weight: 600;
      -moz-text-align-last: justify;
      text-align-last: justify;
    }

    .advertising-phrase-sub{
      font-size: 2.5vw;
      font-weight: 600;
      -moz-text-align-last: justify;
      text-align-last: justify;
    }
  

   /*スマホ表示ここからーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー */

  .machine{

    width:100%;
  }
  .machine-container{

    width: 80vw;
    margin: 0 auto;
    clear: both;
    
  }

  .machine-text{

    text-align: center;
    font-size:20px;
    color:#000;
  }
  
  .machine-line{

    border:0.2px solid #707070;
    margin: 35px auto;
    display: block;
    text-align: center;
    width: 70vw;
  }

  .machine-toptextbox{

    width: 70vw;
    margin: 0 auto;
    line-height: 1.5em;
    font-weight: 100;
    color:#000;
    margin-top:50px;
    display: block;
    text-align: justify;
    text-align-last: left;
  }
  
  .machine-topimg{

    margin: 60px auto;
    display: block;
    width:100%;
  }

  .machine-contentsbox{

    display: block;
    width: 100%;
    margin: 20px auto;
    text-align: center;
    


  }

  .machine-contents{

    
    /*display: inline-block;*/
    clear: both;
    width: 60vw;
    text-align: center;
    vertical-align:top;
    margin: 0 50px;
    text-align: justify;
   text-justify: inter-ideograph;
    
  }

  .machine-name{

    height: 20px;
    text-align: center;
    margin: 0 auto;
    display: block;
    margin-bottom:30px;
  }

  .machine-textbox{

    vertical-align:top;
    font-weight: 100;
    color:#000;
    /*width: 170px;*/
    margin-right: 0;
    display: block;
    line-height: 1.5em;
    font-size:15px;
    margin: 30px auto;
    text-align: justify;
    text-align-last: left;

  }

  .machine-img{

    width: 30vw;
    margin: 0 auto;
    display: block;
  }
  

}

</style>